/*
  DN wishlist quick-shop image gallery (additive companion to dn-wishlist-quickshop.js).

  Owner request 2026-07-30: in the wishlist drawer quick-shop, the prev/next arrows
  should page through the SELECTED product's images (not jump to the next wishlisted
  product), plus a strip of up to ~5 thumbnails that slide.

  Non-invasive: the original minified quick-shop file is untouched. This script:
    - watches the wishlist drawer for the quick-shop opening / switching product,
    - fetches that product's images from /products/{handle}.js,
    - CLONES the existing .dn-qs__nav arrows (which strips their product-nav click
      handlers) and rebinds them to image paging,
    - injects a horizontally-scrollable thumbnail strip under the image.
  If a product has <=1 image the arrows are simply hidden (nothing to browse).
*/
(function () {
  "use strict";

  var drawer = document.getElementById("offcanvas-wishlist");
  if (!drawer) return;

  var THUMB = "160x160";
  var MAIN = "800x800";
  var imageCache = {}; // handle -> [urls]
  var state = { handle: null, images: [], index: 0, syncing: false };
  var lastHandle = null;

  function resize(src, dims) {
    if (!src) return "";
    if (window.Shopify && typeof window.Shopify.resizeImage === "function") {
      try { return window.Shopify.resizeImage(src, dims, "center"); } catch (e) {}
    }
    return src;
  }

  // Normalize a CDN url down to its original filename so a resized main image
  // (foo_800x800_crop_center.jpg) matches the source list entry (foo.jpg).
  function normName(u) {
    var f = (u || "").split("?")[0].split("/").pop();
    return f.replace(/_(\d+)x(\d+)(_crop_[a-z]+)?(?=\.[a-z0-9]+$)/i, "");
  }

  function handleFromQuickshop(qs) {
    var v = qs.querySelector(".dn-qs__view");
    var href = v && v.getAttribute("href");
    var m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchImages(handle) {
    if (imageCache[handle]) return Promise.resolve(imageCache[handle]);
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var imgs = p && Array.isArray(p.images) ? p.images.slice() : [];
        imageCache[handle] = imgs;
        return imgs;
      })
      .catch(function () { return []; });
  }

  function updateActiveThumb(qs) {
    var thumbs = qs.querySelectorAll(".dn-qsg__thumb");
    for (var i = 0; i < thumbs.length; i++) {
      var active = +thumbs[i].getAttribute("data-i") === state.index;
      thumbs[i].classList.toggle("is-active", active);
      thumbs[i].setAttribute("aria-current", active ? "true" : "false");
      if (active && thumbs[i].scrollIntoView) {
        try { thumbs[i].scrollIntoView({ inline: "nearest", block: "nearest" }); } catch (e) {}
      }
    }
  }

  function showImage(qs, idx) {
    var img = qs.querySelector(".dn-qs__img");
    if (!img || !state.images[idx]) return;
    state.index = idx;
    state.syncing = true;
    img.src = resize(state.images[idx], MAIN);
    setTimeout(function () { state.syncing = false; }, 80);
    updateActiveThumb(qs);
  }

  // Keep the active thumbnail in step with whatever image the quick-shop itself
  // shows (e.g. after a variant change swaps the main image).
  function syncActiveToCurrent(qs) {
    var img = qs.querySelector(".dn-qs__img");
    if (!img) return;
    var cur = normName(img.src);
    var found = -1;
    for (var i = 0; i < state.images.length; i++) {
      if (normName(state.images[i]) === cur) { found = i; break; }
    }
    state.index = found >= 0 ? found : state.index;
    updateActiveThumb(qs);
  }

  function takeOverArrow(qs, selector, delta) {
    var btn = qs.querySelector(selector);
    if (!btn) return;
    var clone = btn.cloneNode(true); // drops the original product-nav listeners
    clone.removeAttribute("hidden");
    clone.classList.add("dn-qsg-arrow");
    clone.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var n = state.images.length;
      if (n < 2) return;
      showImage(qs, (state.index + delta + n) % n);
    });
    btn.parentNode.replaceChild(clone, btn);
  }

  function hideArrow(qs, selector) {
    var btn = qs.querySelector(selector);
    if (!btn) return;
    var clone = btn.cloneNode(true);
    clone.setAttribute("hidden", "");
    clone.classList.add("dn-qsg-arrow");
    btn.parentNode.replaceChild(clone, btn);
  }

  function buildGallery(qs, handle, images) {
    state.handle = handle;
    state.images = images;
    state.index = 0;

    var old = qs.querySelector(".dn-qsg__thumbs");
    if (old) old.remove();

    var media = qs.querySelector(".dn-qs__media");
    if (!media) return;

    if (images.length <= 1) {
      // Nothing to page through: neutralize the product-nav arrows.
      hideArrow(qs, ".dn-qs__nav--prev");
      hideArrow(qs, ".dn-qs__nav--next");
      return;
    }

    takeOverArrow(qs, ".dn-qs__nav--prev", -1);
    takeOverArrow(qs, ".dn-qs__nav--next", 1);

    var strip = document.createElement("div");
    strip.className = "dn-qsg__thumbs";
    strip.setAttribute("role", "group");
    strip.setAttribute("aria-label", "Product images");

    images.forEach(function (src, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "dn-qsg__thumb" + (i === 0 ? " is-active" : "");
      b.setAttribute("data-i", i);
      b.setAttribute("aria-label", "Show image " + (i + 1) + " of " + images.length);
      var im = document.createElement("img");
      im.src = resize(src, THUMB);
      im.alt = "";
      im.loading = "lazy";
      im.width = 64;
      im.height = 64;
      b.appendChild(im);
      b.addEventListener("click", function (e) {
        e.preventDefault();
        showImage(qs, i);
      });
      strip.appendChild(b);
    });

    media.parentNode.insertBefore(strip, media.nextSibling);
    syncActiveToCurrent(qs); // highlight whichever image is already shown
  }

  function maybeInit() {
    try { maybeInitInner(); } catch (e) { /* never break the live quick-shop */ }
  }

  function maybeInitInner() {
    var qs = drawer.querySelector(".dn-qs");
    if (!qs) return;
    var handle = handleFromQuickshop(qs);
    if (!handle) return;

    if (handle === lastHandle && qs.querySelector(".dn-qsg__thumbs")) {
      // same product, gallery already built: just keep the active thumb in sync
      if (!state.syncing) syncActiveToCurrent(qs);
      return;
    }
    lastHandle = handle;
    fetchImages(handle).then(function (images) {
      // guard: the product may have changed again while fetching
      if (handleFromQuickshop(qs) === handle) buildGallery(qs, handle, images);
    });
  }

  var mo = new MutationObserver(function () { maybeInit(); });
  mo.observe(drawer, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href", "src"]
  });
  maybeInit();
})();
